import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
  InputAdornment,
} from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MdModeEdit, MdOutlineClose } from "react-icons/md";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNotification } from "../../../../hooks/useNotification";
import useStyles from "../../../../themes/style.js";
import { getEmpName } from "../../../../utils/constant";
import { Autocomplete } from "@material-ui/lab";

const FinalSettlement = ({ userDetails, onUpdate }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
  const [empLeavingDate, setEmpLeavingDate] = useState(new Date());
  const [leaveBalanceId, setLeaveBalanceId] = useState("");
  const [finalSettlementData, setFinalSettlementData] = useState({});
  const [leaveBalanceDetails, setLeaveBalanceDetails] = useState({});

  const handleNotificationCall = useNotification();
  const validationSchema = Yup.object().shape({
    resignationSubmittedOn: Yup.date()
      .required("Employee Resignation Date is required")
      .typeError("Invalid Date"),
    leavingDate: Yup.date()
      .required("Employee Leaving Date is required")
      .typeError("Invalid Date"),
    settlementDate: Yup.date()
      .required("Employee Settlement Date is required")
      .typeError("Invalid Date"),
    leavingReason: Yup.string().notRequired().nullable(),
    noticeperiod: Yup.number()
      .required("Notice Period in Days")
      .typeError("Value Must be a number"),
    daysServed: Yup.number()
      .required("No of Days Served in Office")
      .typeError("Value Must be a number"),
    daysWorked: Yup.number()
      .required("No of Days Worked in Office")
      .typeError("Value Must be a number"),
    // leaveType: Yup.string().required("Mention Employee Leaving Reason"),
    personal: Yup.number()
      .required("Encash Days field is required")
      .typeError("Value Must be a number"),
    remarks: Yup.string().notRequired().nullable(),
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      leavingDate: moment().format("YYYY-MM-DD"),
    },
  });

  useEffect(() => {
    if (userDetails) {
      const leaveDetails = userDetails.leave_balance;

      setFinalSettlementData(userDetails.finalSettlement);
      setLeaveBalanceId(leaveDetails?.id);
      setValue("personal", leaveDetails?.personal || 0);
      setLeaveBalanceDetails(leaveDetails);
    }
  }, [userDetails]);

  const handleFinalSettlementSubmit = async (values) => {
    const monthIndex = new Date(empLeavingDate).getMonth();
    const fullyear = new Date(empLeavingDate).getFullYear();
    try {
      setLoader(true);
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}payslip/finalsettlement`,
        {
          ...values,
          payrollMonth: monthIndex,
          payrollYear: fullyear,
          userId: userDetails.id,
          leavebalanceId: leaveBalanceId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  return (
    <div>
      <Box>
        <div className="emp-profile-details-table-card">
          <h3 className="gradienttext">Final Settlement</h3>

          {/* {!enableEdit && !finalSettlementData ? (
            <button
              className="emp-profile-edit-button"
              onClick={() => setEnableEdit(!enableEdit)}
            >
              <MdModeEdit color="#056dfa" className="svg-icon" />
              <span className="lable">Edit</span>
            </button>
          ) : enableEdit && !finalSettlementData ? (
            <button
              className="emp-profile-edit-button emp-profile-cancel-button"
              onClick={() => setEnableEdit(false)}
            >
              <MdOutlineClose color="#fa0505" className="svg-icon" />
              <span className="lable">Cancel</span>
            </button>
          ) : (
            <></>
          )} */}

          {finalSettlementData ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <table className="emp-profile-details-table">
                  <tbody>
                    <tr>
                      <td>Resignation Submitted On</td>
                      <td>
                        {(finalSettlementData?.resignationSubmittedOn &&
                          moment(
                            finalSettlementData?.resignationSubmittedOn,
                          ).format("DD-MM-YYYY")) || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Leaving Date</td>
                      <td>
                        {(finalSettlementData.leavingDate &&
                          moment(finalSettlementData.leavingDate).format(
                            "DD-MM-YYYY",
                          )) || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Leaving Reason</td>
                      <td>
                        {finalSettlementData.leavingReason ? (
                          finalSettlementData.leavingReason
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Settlement Date</td>
                      <td>
                        {(finalSettlementData?.settlementDate &&
                          moment(finalSettlementData?.settlementDate).format(
                            "DD-MM-YYYY",
                          )) || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Notice Period</td>
                      <td>
                        {userDetails.salary_detail?.probationPeriod ? (
                          finalSettlementData?.noticeperiod
                        ) : (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>No of Days Served</td>
                      <td>
                        {finalSettlementData?.daysServed || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <table className="emp-profile-details-table">
                  <tbody>
                    <tr>
                      <td>Work Days</td>
                      <td>
                        {moment(
                          finalSettlementData?.leavingDate,
                        ).daysInMonth() || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Days Worked</td>
                      <td>
                        {finalSettlementData?.daysWorked || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Encash Days</td>
                      <td>
                        {leaveBalanceDetails?.personal?.toString() || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>Remarks</td>
                      <td>
                        {finalSettlementData?.remarks || (
                          <span className="emp-details-unvailable">
                            Unavailable
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
          ) : (
            <form
              onSubmit={handleSubmit(handleFinalSettlementSubmit)}
              style={{ padding: "10px" }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <h3 className="gradient-text-sub-heading">
                      Resignation Details
                    </h3>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="resignationSubmittedOn">
                          Resignation Submitted On
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="date"
                            placeholder="Select Resignation Submitted On Date "
                            {...register("resignationSubmittedOn")}
                            error={errors.resignationSubmittedOn ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.resignationSubmittedOn?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="leavingDate">
                          Leaving Date
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="date"
                            placeholder="Select Employee Leaving Date"
                            onChange={(e) => setEmpLeavingDate(e.target.value)}
                            {...register("leavingDate")}
                            error={errors.leavingDate ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.leavingDate?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="leavingReason">
                          Leaving Reason
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="text"
                            placeholder="Enter Leaving Reason"
                            {...register("leavingReason")}
                            error={errors.leavingReason ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.leavingReason?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="settlementDate">
                          Settlement Date
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="date"
                            placeholder="Select Employee Settlement Date "
                            {...register("settlementDate")}
                            error={errors.settlementDate ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.settlementDate?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box>
                    <h3 className="gradient-text-sub-heading">Notice Pay</h3>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="noticeperiod">
                          Notice Period
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{
                              disableUnderline: true,
                              inputProps: { min: 0 },
                              inputMode: "numeric",
                              endAdornment: (
                                <InputAdornment
                                  style={{ marginRight: "6px", color: "blue" }}
                                  position="end"
                                >
                                  Days
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="number"
                            placeholder="Notice Period in Days"
                            {...register("noticeperiod")}
                            error={errors.noticeperiod ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.noticeperiod?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="daysServed">
                          No of Days Served
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{
                              disableUnderline: true,
                              inputProps: { min: 0 },
                              inputMode: "numeric",
                              endAdornment: (
                                <InputAdornment
                                  style={{ marginRight: "6px", color: "blue" }}
                                  position="end"
                                >
                                  Days
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="number"
                            placeholder="No of Days Served in Days"
                            {...register("daysServed")}
                            error={errors.daysServed ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.daysServed?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    <h3 className="gradient-text-sub-heading">Work Days</h3>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <table className="emp-profile-details-table">
                          <tbody>
                            <tr>
                              <td>Work Days</td>
                              <td>
                                {" "}
                                {moment(
                                  watch("leavingDate"),
                                ).daysInMonth()}{" "}
                                Days
                              </td>
                            </tr>
                            <tr>
                              <td>Days Worked</td>
                              <td className="d-flex w-100">
                                <Box ml={2}>
                                  <TextField
                                    InputProps={{
                                      disableUnderline: true,
                                      inputProps: { min: 0 },
                                      inputMode: "numeric",
                                      endAdornment: (
                                        <InputAdornment
                                          style={{
                                            marginRight: "6px",
                                            color: "blue",
                                          }}
                                          position="end"
                                        >
                                          Days
                                        </InputAdornment>
                                      ),
                                    }}
                                    classes={{ root: classes.customTextField }}
                                    size="small"
                                    type="number"
                                    placeholder="Days Worked in office"
                                    {...register("daysWorked")}
                                    error={errors.daysWorked ? true : false}
                                  />

                                  <Typography variant="inherit" color="error">
                                    {errors.daysWorked?.message}
                                  </Typography>
                                </Box>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    <h3 className="gradient-text-sub-heading">
                      Leave Encashment
                    </h3>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="personal">
                          Encash Days
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{
                              disableUnderline: true,
                              inputProps: { min: 0 },
                              inputMode: "numeric",
                              endAdornment: (
                                <InputAdornment
                                  style={{ marginRight: "6px", color: "blue" }}
                                  position="end"
                                >
                                  Days
                                </InputAdornment>
                              ),
                            }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="number"
                            placeholder="Enter Encash Days"
                            {...register("personal")}
                            error={errors.personal ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.personal?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box>
                    <h3 className="gradient-text-sub-heading">Remarks</h3>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <InputLabel shrink htmlFor="remarks">
                          Remarks
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            type="text"
                            placeholder="Enter Remarks"
                            {...register("remarks")}
                            error={errors.remarks ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.remarks?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box display="flex" gridGap={6} justifyContent="end" mt={6}>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={() => setEnableEdit(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                    >
                      Save
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}></Grid>
              </Grid>
            </form>
          )}
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </div>
  );
};

export default FinalSettlement;
